export default __webpack_public_path__ + "static/media/step4.19f60c29.png";